import './App.css';

function App() {
  return (
    <div className='page'>
      <h2>Politique de confidentialité d'<strong>Arkanya</strong></h2>
      <p>Pour recevoir des informations sur les Données personnelles, les objectifs et les parties avec qui elles sont partagées, veuillez contacter le Propriétaire.</p>
      <section>
        <h3>Propriétaire et Responsable du traitement</h3>
        <p><strong>Arkanya</strong></p>
        <p><u>Courriel de contact du Propriétaire :</u> <strong>contact@arkanya.fr</strong></p>
      </section>
      <section>
        <h3>Types de Données collectées</h3>
        <p>Le propriétaire ne collecte aucun types de Données personnelles.</p>
      </section>
      <section>
        <h3>Lieu de traitement</h3>
        <p>Le propriétaire ne collectant aucun type de données personnelles, il n'y a donc aucun lieu de traitement de ces données.</p>
      </section>
      <section>
        <h3>Droits des Utilisateurs</h3>
        <p>Les Utilisateurs peuvent exercer certains droits concernant leurs Données traitées par le Propriétaire.</p>
        <br />
        <p>Les Utilisateurs ont notamment le droit de faire ce qui suit, dans la mesure où la loi le permet :</p>
        <p>Retirer leur consentement à tout moment. Les Utilisateurs ont le droit de retirer leur consentement s'ils ont déjà consenti leur consentement au traitement de leurs Données personnelles.</p>
      </section>
      <section>
        <h3>Comment exercer ces droits</h3>
        <p>Toute demande d'exercice des droits de l'Utilisateur peut être adressée au Propriétaire grâce aux coordonnées fournies dans le présent document. Ces demandes peuvent être exercées gratuitement et recevront une réponse du Propriétaire, apportant aux Utilisateurs les informations requises par la loi, le plus tôt possible et toujours dans un délai d'un mois. Toute rectification ou tout effacement de Données personnelles ou toute limitation du traitement seront communiqués par le Propriétaire à chaque destinataire auquel les Données personnelles ont été communiquées, le cas échéant, sauf si cela s’avère impossible ou implique un effort disproportionné. À la demande des Utilisateurs, le Propriétaire les renseignera sur ces destinataires.</p>
      </section>
      <section>
        <h3>Modifications de la présente politique de confidentialité</h3>
        <p>Le Propriétaire se réserve le droit d'apporter des modifications à la présente politique de confidentialité, à tout moment, en informant ses Utilisateurs sur cette page et éventuellement dans cette cette Application ou – pour autant que cela soit techniquement et légalement possible – en envoyant une notification aux Utilisateurs par l'intermédiaire des coordonnées disponibles pour le Propriétaire. Il est fortement recommandé de consulter cette page fréquemment, en se référant à la date de la dernière modification indiquée en bas.</p>
        <br />
        <p>Si les modifications influencent les activités de traitement effectuées sur la base du consentement de l'Utilisateur, le Propriétaire doit recueillir un nouveau consentement de l'Utilisateur lorsque nécessaire.</p>
      </section>
      <div className='line' />
      <section>
        <h3>Informations légales</h3>
        <p>Cette politique de confidentialité concerne uniquement les applications suivante: <strong><i>Petit Bac Express</i></strong> et <strong><i>Fight Calculator</i></strong>.</p>
        <br />
        <p><strong>Dernière mise à jour :</strong> 14 Avril 2025</p>
      </section>
    </div>
  );
}

export default App;
